"use client";

import { createContext, useContext } from "react";

export type TranscriptTheme = "light" | "dark" | "color";

interface TranscriptDisplayContextType {
  theme: TranscriptTheme;
  colorHex: string;
  fontMultiplier: number;
  showAllBlocksAsSeen: boolean;
}

const TranscriptDisplayContext = createContext<
  TranscriptDisplayContextType | undefined
>(undefined);

export const useTranscriptDisplay = () => {
  const context = useContext(TranscriptDisplayContext);
  if (!context) {
    throw new Error(
      "useTranscriptDisplay must be used within a TranscriptDisplayProvider",
    );
  }
  return context;
};

export const TranscriptDisplayProvider: React.FC<
  TranscriptDisplayContextType & { children: React.ReactNode }
> = ({ theme, colorHex, fontMultiplier, showAllBlocksAsSeen, children }) => (
  <TranscriptDisplayContext.Provider
    value={{ theme, colorHex, fontMultiplier, showAllBlocksAsSeen }}
  >
    {children}
  </TranscriptDisplayContext.Provider>
);
